import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

interface AppEnvironment {
  tenant?: string;
  apiUrl?: string;
  pgaasUrl?: string;
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly env = environment as AppEnvironment;
  protected readonly title = signal('callcenter');
  protected readonly tenant = signal(this.env.tenant ?? '');
  protected readonly apiUrl = signal(this.env.apiUrl ?? '');
}
